import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

export const ModalContext = createContext();

const ModalProvider = (props) => {

    const [ recipeID, setRecipeID ] = useState(null);
    const [ detail, setDetail ] = useState({});

    useEffect(() => {
        const getRecipeDetail = async () => {
            if (!recipeID) return;

            const url = `https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=${ recipeID }`;
            const result = await axios.get(url);
            setDetail(result.data.drinks[0]);
        }
        getRecipeDetail();
    }, [recipeID]);

    return ( 
        <ModalContext.Provider
            value={{
                detail,
                setRecipeID,
                setDetail
            }}
        >
            { props.children }
        </ModalContext.Provider>
     );
}
 
export default ModalProvider;